<template>
    <div
        class="flex flex-col items-center justify-center py-8 px-4 bg-white border-t border-gray-200"
    >
        <svg
            class="mb-3"
            data-testid="sms-consent-expired-icon"
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            aria-hidden="true"
            focusable="false"
        >
            <circle
                cx="16.5"
                cy="16.5"
                r="15.84"
                fill="#F5F5F5"
                stroke="#3B3B3B"
                stroke-width="1.32"
            />
            <line
                x1="7.12579"
                y1="3.56107"
                x2="26.4858"
                y2="29.0811"
                stroke="#3B3B3B"
                stroke-width="1.32"
            />
        </svg>

        <h3
            class="text-lg font-semibold text-gray-700 mb-2"
            data-testid="sms-consent-expired-heading"
        >
            {{ t('smsCommunication.consentExpired') }}
        </h3>

        <p
            class="text-md text-gray-700 text-center max-w-md whitespace-pre-line"
            data-testid="sms-consent-expired-message"
        >
            {{ t('smsCommunication.consentExpiredMessage') }}
        </p>
    </div>
</template>

<script setup lang="ts">
    import { useI18n } from '@/hooks/useI18n.ts';

    const { t } = useI18n();
</script>
